"use strict";

/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSyncTransform = void 0;
const isSyncTransform = transform => {
  return transform.length === 1;
};
exports.isSyncTransform = isSyncTransform;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJpc1N5bmNUcmFuc2Zvcm0iLCJ0cmFuc2Zvcm0iLCJsZW5ndGgiLCJleHBvcnRzIl0sInNvdXJjZXMiOlsiLi4vLi4vc3JjL3R5cGVzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF0sIm1hcHBpbmdzIjoiOztBQUFBOzs7OztBQVlPLE1BQU1BLGVBQWUsR0FDeEJDLFNBQXFDLElBQ0E7RUFDckMsT0FBT0EsU0FBUyxDQUFDQyxNQUFNLEtBQUssQ0FBQztBQUNqQyxDQUFDO0FBSllDLE9BQUEsQ0FBQUgsZUFBZSxHQUFBQSxlQUFBIiwiaWdub3JlTGlzdCI6W119